function realFormatSecond(second) {
  var secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '00:00'
  }
}
import CountDown from '@/components/CountDown/CountDown.vue'
import AutoPlay from './autoPlay'

export default {
  components: {
    CountDown,
    AutoPlay
  },
  props: { audioUrl: '', count: 0 },
  data() {
    return {
      playing: false,
      playingUrl: require('@/assets/playing.png'),
      pauseUrl: require('@/assets/pause.png'),
      currentTime: 0,
      timeFull: '00:00',
      time: '00:00',
      volume: 100,
      maxTime: 0,
      maxTimeCount: 0,
      url: '',
      reset: true,
      state: 'count',
      playTip: false,
      playbackRate: '', // 默认播放速度为1x
      playbackRateOptions: [
        { value: '0.5', label: '0.5x' },
        { value: '0.75', label: '0.75x' },
        { value: '1', label: '1x' },
        { value: '1.25', label: '1.25x' },
        { value: '1.5', label: '1.5x' },
        { value: '2', label: '2x' }
      ]
    }
  },
  mounted() {
    this.init()
    this.audioTime()
  },
  methods: {
    endCountDown() {
      this.playAudio()
    },
    // 获取音频时间
    audioTime() {
      // let audios = document.getElementsByTagName('audio')
      // console.log(document.getElementsByTagName('audio'), '||', this.$refs.audio)
      // let count = setInterval(() => {
      //     if (this.maxTimeCount > 0) {
      //         clearInterval(count)
      //         this.timer()
      //         return
      //     }
      //     if (audios[0].duration != NaN) {
      //         this.maxTimeCount = parseInt(audios[0].duration)
      //     }
      // }, 1000);
    },
    // 计算音频
    timer() {
      let min, sec
      min = sec = 0
      min = parseInt(this.maxTimeCount / 60)
      sec = parseInt(this.maxTimeCount % 60)
      if (this.maxTimeCount < 60) {
        min = '0'
      }
      if (sec < 10) {
        sec = '0' + sec
      }
      if (min < 10) {
        min = '0' + min
      }
      this.timeFull = min + ':' + sec
    },
    init() {
      if (typeof this.audioUrl == 'object') {
        this.url = this.audioUrl.url
      } else {
        this.url = this.audioUrl
      }
    },
    playAudio() {
      this.playTip = false
      this.state = 'play'
      let audios = document.getElementsByTagName('audio')
      let btn = document.getElementsByClassName('btn-controls')
      this.$emit('funs', 'ok', this.maxTime)
      if (this.playing) {
        this.$refs.audio.pause()
        this.playing = false
      } else {
        // 如果设置了排他性，当前音频播放是，其他音频都要暂停
        ;[...audios].forEach((item) => {
          item.pause()
        })
        ;[...btn].forEach((item) => {
          item.src = require('@/assets/pause.png')
        })
        this.$refs.audio.play().catch((e) => {
          this.playing = false
          this.playTip = true
        })

        this.playing = true
      }
    },
    onLoadedmetadata(res) {
      this.time = '00:00'
      this.maxTime = parseInt(res.target.duration)
      this.timeFull = realFormatSecond(res.target.duration)
    },
    onTimeupdate(res) {
      this.currentTime = parseInt(res.target.currentTime)
      this.time = realFormatSecond(res.target.currentTime)

      if (this.currentTime == this.maxTime) {
        this.playing = false
        // this.currentTime = 0
        // this.time = '00:00'
        // setTimeout(() => {
        //     this.playing = false
        //     this.time = realFormatSecond()
        //     this.currentTime = 0
        // }, 1000);
        if (this.currentTime) {
          this.state = 'end'
          this.$emit('audio-end')
        }
      }
    },
    changeAudio(value) {
      this.$refs.audio.currentTime = parseInt(value)
      this.$emit('time-chg',this.maxTime - this.$refs.audio.currentTime)
    },
    // 控制音量
    changeVolume() {
      this.$refs.audio.volume = this.volume / 100
    },
    // 更改播放速度
    changePlaybackRate() {
      this.$refs.audio.playbackRate = parseFloat(this.playbackRate);
    },
    getRemainTime(){
      return this.maxTime - this.$refs.audio.currentTime
    }
  },
  watch: {
    audioUrl() {
      this.maxTimeCount = 0
      this.reset = false
      this.$nextTick(() => {
        this.reset = true
        this.init()
        this.audioTime()
      })
    },
    playing(newVal, oldVal) {
      console.log('playing:', newVal, oldVal)
      this.$emit('playing-change', {
        playing: newVal,
        oldVal: oldVal
      });
    }
  }
}
